import React from 'react';
import { Landmark, TrendingUp } from 'lucide-react';

const TaxAndInflationSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Landmark className="w-5 h-5 mr-2 text-blue-500" />
        Налоги и инфляция
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Инфляция */}
        {formData.adjustForInflation && (
          <div>
            <label htmlFor="inflation" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <TrendingUp className="w-4 h-4 mr-2 text-blue-500" />
              Ожидаемая инфляция (% в год)
            </label>
            <input
              type="text"
              id="inflation"
              name="inflation"
              value={formData.inflation}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.inflation ? 'input-error' : ''}`}
              placeholder="Введите процент"
            />
            {errors.inflation && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.inflation}
              </p>
            )}
          </div>
        )}

        {/* Налоговая ставка */}
        <div>
          <label htmlFor="taxRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Ставка налога (НДФЛ, %)
          </label>
          <input
            type="text"
            id="taxRate"
            name="taxRate"
            value={formData.taxRate}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.taxRate ? 'input-error' : ''}`}
            placeholder="Введите процент"
          />
          {errors.taxRate && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.taxRate}
            </p>
          )}
          <div className="mt-2 grid grid-cols-3 gap-1">
            {[13, 15, 0].map(rate => (
              <button
                key={rate}
                type="button"
                onClick={() => handleInputChange({
                  target: { name: 'taxRate', value: rate.toString() }
                })}
                className="text-xs px-2 py-1 rounded border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
              >
                {rate === 0 ? 'Без налога' : `${rate}%`}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-4 bg-blue-100 dark:bg-blue-900/30 p-3 rounded-lg border border-blue-200 dark:border-blue-800">
        <div className="flex items-start">
          <Landmark className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              Налоговая информация
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              В России стандартная ставка НДФЛ на доходы от инвестиций составляет 13% для налоговых резидентов
              и 15% для нерезидентов. Для долгосрочных инвестиций можно использовать ИИС с налоговыми льготами.
              Инфляция снижает реальную доходность инвестиций, поэтому важно её учитывать.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaxAndInflationSection;